var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 22.75C6.06609 22.75 1.24609 17.93 1.24609 12C1.24609 6.07 6.06609 1.25 11.9961 1.25C17.9261 1.25 22.7461 6.07 22.7461 12C22.7461 17.93 17.9261 22.75 11.9961 22.75ZM11.9961 2.75C6.89609 2.75 2.74609 6.9 2.74609 12C2.74609 17.1 6.89609 21.25 11.9961 21.25C17.0961 21.25 21.2461 17.1 21.2461 12C21.2461 6.9 17.0961 2.75 11.9961 2.75Z",
    fill: "#713FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 12.748H8.00391C7.59391 12.748 7.25391 12.408 7.25391 11.998C7.25391 11.588 7.59391 11.248 8.00391 11.248H16.0039C16.4139 11.248 16.7539 11.588 16.7539 11.998C16.7539 12.408 16.4139 12.748 16.0039 12.748Z",
    fill: "#713FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 16.752C11.5939 16.752 11.2539 16.412 11.2539 16.002V8.00195C11.2539 7.59195 11.5939 7.25195 12.0039 7.25195C12.4139 7.25195 12.7539 7.59195 12.7539 8.00195V16.002C12.7539 16.412 12.4139 16.752 12.0039 16.752Z",
    fill: "#713FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRound);
export default __webpack_public_path__ + "static/media/plus-round.7f17fa5b.svg";
export { ForwardRef as ReactComponent };